import React from 'react';
import PropTypes from 'prop-types';
import DataCacheService from '@/shared/services/DataCacheService';

export const hasAssignments = () => {
  const dataCache = DataCacheService.getDataCache();
  if (!dataCache) return false;
  return !!dataCache.assignmentsEnabled;
};

export const showWhenAssignmentsEnabled = WrappedComponent => ({ ...passThroughProps }) => {
  if (!hasAssignments()) return null;
  return <WrappedComponent {...passThroughProps} />;
};

const HasAssignments = ({ children = null, fallback = null }) => {
  if (!children) return null;
  if (!hasAssignments()) return fallback;
  return children;
};

HasAssignments.propTypes = {
  children: PropTypes.node,
  fallback: PropTypes.node,
};
export default HasAssignments;
